<template>

  <!-- Table Container Card -->
  <b-card
      class="mb-0"
      no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            cols="12"
            md="8"
        >
          <label>Afficher</label>
          <v-select
              v-model="perPage"
              :clearable="false"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              class="per-page-selector d-inline-block mx-50"
          />
          <label>Banques</label>
        </b-col>

        <!-- Search -->
        <b-col
            cols="12"
            md="4"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
                v-model="searchQuery"
                class="d-inline-block"
                placeholder="Rechercher..."
            />
          </div>
        </b-col>
      </b-row>

    </div>

    <b-table
        ref="refBankListTable"
        :fields="tableColumns"
        :items="fetchBanks"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDirDesc"
        class="position-relative"
        empty-text="Aucune donnée enregistrée"
        primary-key="id"
        responsive
        show-empty
    >

      <!-- Column: Account -->
      <template #cell(bank)="data">
        <b-media vertical-align="center">
          <template #aside>
            <b-avatar
                :src="data.item.avatar"
                :text="avatarText(data.item.name)"
                :to="{ name: 'apps-banks-view', params: { id: data.item.uid } }"
                size="32"
                variant="light-primary"
            />
          </template>
          <b-link
              :to="{ name: 'apps-banks-view', params: { id: data.item.uid } }"
              class="font-weight-bold d-block text-nowrap"
          >
            {{ data.item.name }}
          </b-link>
          <small class="text-muted">XOF {{ amountToCurrency(data.item.amount, 'fr-FR', null) }}</small>
        </b-media>
      </template>

      <!-- Column: Status -->
      <template #cell(status)="data">
        <b-badge
            :variant="`light-${resolveBankStatusVariant(data.item.is_active ? 'active' : 'inactive')}`"
            class="text-capitalize"
            pill
        >
          {{ data.item.is_active ? 'Active' : 'Inactive' }}
        </b-badge>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <b-dropdown
            :right="$store.state.appConfig.isRTL"
            no-caret
            variant="link"
        >

          <template #button-content>
            <feather-icon
                class="align-middle text-body"
                icon="MoreVerticalIcon"
                size="16"
            />
          </template>
          <b-dropdown-item :to="{ name: 'apps-banks-view', params: { id: data.item.uid } }">
            <feather-icon icon="FileTextIcon"/>
            <span class="align-middle ml-50">Details</span>
          </b-dropdown-item>

          <!--            <b-dropdown-item :to="{ name: 'apps-users-edit', params: { id: data.item.id } }">-->
          <!--              <feather-icon icon="EditIcon"/>-->
          <!--              <span class="align-middle ml-50">Edit</span>-->
          <!--            </b-dropdown-item>-->

          <!--            <b-dropdown-item>-->
          <!--              <feather-icon icon="TrashIcon"/>-->
          <!--              <span class="align-middle ml-50">Delete</span>-->
          <!--            </b-dropdown-item>-->
        </b-dropdown>
      </template>

    </b-table>
    <div class="mx-2 mb-2">
      <b-row>

        <b-col
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
            cols="12"
            sm="6"
        >
            <span class="text-muted">Affichage de {{ dataMeta.from }} à {{ dataMeta.to }} sur {{
                dataMeta.of
              }} Banques</span>
        </b-col>
        <!-- Pagination -->
        <b-col
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
            cols="12"
            sm="6"
        >

          <b-pagination
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalBanks"
              class="mb-0 mt-1 mt-sm-0"
              first-number
              last-number
              next-class="next-item"
              prev-class="prev-item"
          >
            <template #prev-text>
              <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormInput,
  BLink,
  BMedia,
  BPagination,
  BRow,
  BTable,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {avatarText} from '@core/utils/filter'
import useBanksList from './useBanksList'
import {amountToCurrency} from "../../../../utils/formatAmount";

export default {
  methods: {amountToCurrency},
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,

    vSelect,
  },
  setup() {

    const statusOptions = [
      {label: 'Active', value: 'Active'},
      {label: 'Inactive', value: 'Inactive'},
    ]

    const {
      fetchBanks,
      tableColumns,
      perPage,
      currentPage,
      totalBanks,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refBankListTable,
      refetchData,

      // UI
      resolveBankStatusVariant,
    } = useBanksList()

    return {
      fetchBanks,
      tableColumns,
      perPage,
      currentPage,
      totalBanks,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refBankListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveBankStatusVariant,

      statusOptions
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
